import React from "react";
import { Collapse } from "antd";
import { MdKeyboardBackspace } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import _ from "lodash";

export default function CreditScoreFaqs() {
  const { Panel } = Collapse;
  const navigate = useNavigate();
  let text = "hi";
  const { t } = useTranslation();
  const location = useLocation();
  let Faqs = [
    {
      question: t("creditScore.whatIsCreditScore"),
      answer: t("creditScore.whatIsCreditScoreAnswer"),
      number:1
    },
    {
      question: t("creditScore.whatIsACreditReport"),
      answer: t("creditScore.whatIsACreditReportAnswer"),
      number:2
    },
    {
      question: t("creditScore.creditScoreVsCreditReport"),
      answer: t("creditScore.creditScoreVsCreditReportAnswer"),
      number:3
    },
    {
      question: t("creditScore.howIsCreditScoreCalculated"),
      answer: t("creditScore.howIsCreditScoreCalculatedAnswer"),
      number:4
    },
    // {
    //   question: t("creditScore.howOften"),
    //   answer: t("creditScore.howOftenAnswer"),
    //   number:5
    // },
    {
      question: t("creditScore.creditScoreImportance"),
      answer: t("creditScore.creditScoreImportanceAnswer"),
      number:6
    },
    {
      question: t("creditScore.rangeCredit"),
      answer: t("creditScore.rangeCreditAnswer"),
      number:7
    },
    {
      question: t("creditScore.whyAreCreditScoreDifferent"),
      answer: t("creditScore.whyAreCreditScoreDifferentAnswer"),
      number:8
    }
  ];

  return (
    <div>
      <div
        style={{
          padding: "20px 15px",
          backgroundColor: "#6C63FF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <div
          style={{ flex: 1, marginTop: "5px" }}
          onClick={() =>
            navigate(`/customer/recommendations`, {
              state: {
                hash: _.get(location, "state.hash"),
                isCreditScoreCheck: true,
              },
            })
          }
        >
          <MdKeyboardBackspace style={{ fontSize: "20px", color: "white" }} />
        </div>
        <div
          style={{
            color: "white",
            flex: 15,
            textAlign: "center",
            fontSize: "18px",
          }}
        >
          {t("creditScore.Faqs")}
        </div>
      </div>
      <div style={{ width: "90%", margin: "0 auto" }}>
        <Collapse ghost expandIconPosition={"right"}>
          {Faqs.map((faq)=>{
            return <>
            <Panel
              header={faq.question}
              key={`${faq.number}`}
              style={{ fontSize: "18px" }}
            >
              <p>{faq.answer}</p>
            </Panel>
            <div
              style={{
                border: "0.5px solid lightgray",
                width: "89%",
                margin: "0 auto",
              }}
            ></div>
            </>
          })}
        </Collapse>
      </div>
    </div>
  );
}
